import { render, staticRenderFns } from "./WidgetLineGraph.vue?vue&type=template&id=118857f4&scoped=true&"
import script from "./WidgetLineGraph.vue?vue&type=script&lang=js&"
export * from "./WidgetLineGraph.vue?vue&type=script&lang=js&"
import style0 from "./WidgetLineGraph.vue?vue&type=style&index=0&id=118857f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118857f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118857f4')) {
      api.createRecord('118857f4', component.options)
    } else {
      api.reload('118857f4', component.options)
    }
    module.hot.accept("./WidgetLineGraph.vue?vue&type=template&id=118857f4&scoped=true&", function () {
      api.rerender('118857f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetLineGraph.vue"
export default component.exports